import styled from 'styled-components';
import BaseBox from '../../design/BaseBox';
import palette from '@telus-uds/palette-allium/build/web/palette';

export const TopbarWrapper = styled(BaseBox)`
  background: ${palette.color.purpleTelus};
  color: #ffffff;
  width: 100%;
  padding: 1rem 2rem;
  justify-content: space-between;
  @media screen and (max-width: 992px) {
    padding: 16px;
  }
`;

export const ConfirmationContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  border: 1px solid #aaaaaa;
  padding: 1rem;
  background: #f2eff4;
`;

export const ConfirmationMessage = styled.div`
  max-width: 50%;
  margin-top: 1rem;
  font-weight: 700;
`;

export const Box = styled(BaseBox)`
  margin-top: 20px;
  border: 1px solid #e3e3e3;
  box-shadow: 1px 1px 9px 4px #e3e3e3;
`;

export const FormContainer = styled.div`
  padding: 2rem;
  border: 1px solid rgb(227, 227, 227);
  background: #f2eff4;
`;

export const Label = styled.label`
  color: #2a2c2e;
  word-wrap: break-word;
  font-size: 1rem;
  -webkit-letter-spacing: -0.8px;
  -moz-letter-spacing: -0.8px;
  -ms-letter-spacing: -0.8px;
  letter-spacing: -0.8px;
  line-height: 1.5;
  word-wrap: break-word;
  font-weight: 700;
  margin-bottom: 0.25rem;
`;
